<template>
  <div class="video-list-wrapper">
    <div class="container">

      <!-- 필터 및 검색 컨트롤 -->
      <div class="controls">
        <!-- 타입 필터 -->
        <div class="typeFilter">
          <!-- 타입 전체 보기 드롭다운 (햄버거) -->
          <div class="typeDropdown" ref="typeDropdownContainer">
            <button class="dropdownToggle" @click.stop="toggleTypeDropdown">
              <img src="@/assets/images/dehaze.png" alt="타입 필터 메뉴" class="dehazeIcon" />
            </button>
            <div v-if="showTypeDropdown" class="typeDropdownMenu">
              <button :class="[
                'typeDropdownItem',
                { activeTypeDropdownItem: !selectedTypes.solo && !selectedTypes.duet && !selectedTypes.team && !selectedTypes.dance && !selectedTypes.virtual && !selectedTypes.band },
              ]" @click="selectTypeFromDropdown('all')">
                전체
              </button>
              <button :class="['typeDropdownItem', { activeTypeDropdownItem: selectedTypes.solo }]"
                @click="selectTypeFromDropdown('solo')">
                솔로
              </button>
              <button :class="['typeDropdownItem', { activeTypeDropdownItem: selectedTypes.duet }]"
                @click="selectTypeFromDropdown('duet')">
                듀엣
              </button>
              <button :class="['typeDropdownItem', { activeTypeDropdownItem: selectedTypes.team }]"
                @click="selectTypeFromDropdown('team')">
                팀
              </button>
              <button :class="['typeDropdownItem', { activeTypeDropdownItem: selectedTypes.dance }]"
                @click="selectTypeFromDropdown('dance')">
                댄스
              </button>
              <button :class="['typeDropdownItem', { activeTypeDropdownItem: selectedTypes.virtual }]"
                @click="selectTypeFromDropdown('virtual')">
                버츄얼
              </button>
              <button :class="['typeDropdownItem', { activeTypeDropdownItem: selectedTypes.band }]"
                @click="selectTypeFromDropdown('band')">
                밴드
              </button>
            </div>
          </div>
          <div class="typeFilterScroll" ref="typeFilterScroll">
            <button :class="['likeButton', { activeLike: type === 3 }]" @click="handleLikeFilterClick"
              aria-label="좋아요한 항목만 보기">
              <img class="likeIcon" src="@/assets/images/heart.png" alt="좋아요" />
            </button>
            <button
              :class="['typeButton', { activeType: !selectedTypes.solo && !selectedTypes.duet && !selectedTypes.team && !selectedTypes.dance && !selectedTypes.virtual && !selectedTypes.band }]"
              @click="resetTypes($event)">
              전체
            </button>
            <button :class="['typeButton', { activeType: selectedTypes.solo }]" @click="toggleType('solo', $event)">
              솔로
            </button>
            <button :class="['typeButton', { activeType: selectedTypes.duet }]" @click="toggleType('duet', $event)">
              듀엣
            </button>
            <button :class="['typeButton', { activeType: selectedTypes.team }]" @click="toggleType('team', $event)">
              팀
            </button>
            <button :class="['typeButton', { activeType: selectedTypes.dance }]" @click="toggleType('dance', $event)">
              댄스
            </button>
            <button :class="['typeButton', { activeType: selectedTypes.virtual }]"
              @click="toggleType('virtual', $event)">
              버츄얼
            </button>
            <button :class="['typeButton', { activeType: selectedTypes.band }]" @click="toggleType('band', $event)">
              밴드
            </button>
          </div>
        </div>

        <!-- 검색 및 정렬 -->
        <div class="sortFilter">
          <!-- 날짜 필터 -->
          <div class="dateFilterWrapper">
            <button :class="['dateFilterButton', { dateFilterActive: dateFilterStart || dateFilterEnd }]"
              @click="toggleDateFilter">
              <img class="calendarIcon" src="@/assets/images/calendar_month.png" alt="기간 설정" />
            </button>

            <!-- 날짜 선택 드롭다운 -->
            <div v-if="showDateFilter" class="dateFilterDropdown">
              <div class="dateFilterBody">
                <!-- 시작 년월 -->
                <div class="dateFilterRow">
                  <label class="dateFilterLabel">시작</label>
                  <div class="customSelect" @click="toggleDropdown('startYear')">
                    <span class="customSelectText">{{ dateFilterStartYear ? dateFilterStartYear + '년' : '년도' }}</span>
                    <span class="customSelectArrow">▼</span>
                    <div v-if="openDropdown === 'startYear'" class="customSelectOptions">
                      <div class="customSelectOption" @click.stop="selectYear('start', '')">년도</div>
                      <div v-for="year in availableYears" :key="'sy-' + year"
                        :class="['customSelectOption', { selected: dateFilterStartYear === year }]"
                        @click.stop="selectYear('start', year)">{{ year }}년</div>
                    </div>
                  </div>
                  <div :class="['customSelect', { disabled: !dateFilterStartYear }]"
                    @click="dateFilterStartYear && toggleDropdown('startMonth')">
                    <span class="customSelectText">{{ dateFilterStartMonth ? dateFilterStartMonth + '월' : '월' }}</span>
                    <span class="customSelectArrow">▼</span>
                    <div v-if="openDropdown === 'startMonth'" class="customSelectOptions">
                      <div class="customSelectOption" @click.stop="selectMonth('start', '')">월</div>
                      <div v-for="month in availableStartMonths" :key="'sm-' + month"
                        :class="['customSelectOption', { selected: dateFilterStartMonth === month }]"
                        @click.stop="selectMonth('start', month)">{{ month }}월</div>
                    </div>
                  </div>
                </div>
                <!-- 종료 년월 -->
                <div class="dateFilterRow">
                  <label class="dateFilterLabel">종료</label>
                  <div class="customSelect" @click="toggleDropdown('endYear')">
                    <span class="customSelectText">{{ dateFilterEndYear ? dateFilterEndYear + '년' : '년도' }}</span>
                    <span class="customSelectArrow">▼</span>
                    <div v-if="openDropdown === 'endYear'" class="customSelectOptions">
                      <div class="customSelectOption" @click.stop="selectYear('end', '')">년도</div>
                      <div v-for="year in availableEndYears" :key="'ey-' + year"
                        :class="['customSelectOption', { selected: dateFilterEndYear === year }]"
                        @click.stop="selectYear('end', year)">{{ year }}년</div>
                    </div>
                  </div>
                  <div :class="['customSelect', { disabled: !dateFilterEndYear }]"
                    @click="dateFilterEndYear && toggleDropdown('endMonth')">
                    <span class="customSelectText">{{ dateFilterEndMonth ? dateFilterEndMonth + '월' : '월' }}</span>
                    <span class="customSelectArrow">▼</span>
                    <div v-if="openDropdown === 'endMonth'" class="customSelectOptions">
                      <div class="customSelectOption" @click.stop="selectMonth('end', '')">월</div>
                      <div v-for="month in availableEndMonths" :key="'em-' + month"
                        :class="['customSelectOption', { selected: dateFilterEndMonth === month }]"
                        @click.stop="selectMonth('end', month)">{{ month }}월</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dateFilterFooter">
                <button class="dateFilterReset" @click="resetDateFilter">초기화</button>
                <button class="dateFilterApply" @click="applyDateFilter">적용</button>
              </div>
            </div>
          </div>

          <div class="searchBox">
            <input v-model="searchQuery" type="text" placeholder="제목, 채널 검색" class="searchInput" />
          </div>
          <div class="filterBox">
            <button @click="toggleSort" class="sortButton">
              {{ currentSortLabel }}
              <img class="sortIcon" src="@/assets/images/swap_vert.png" alt="정렬 변경" />
            </button>
          </div>
        </div>
      </div>
      <div class="video-feed">
        <!-- 지연 로딩 및 썸네일 최적화 적용 -->
        <div v-for="video in paginatedItems" :key="video.id" class="video-card">
          <!-- 썸네일 영역 (왼쪽) -->
          <div class="video-thumbnail-wrapper">
            <div class="video-container">
              <div v-if="!loadedVideos[video.id]" class="thumbnail-container" @click="loadVideo(video.id)">
                <img :src="`https://img.youtube.com/vi/${video.id}/sddefault.jpg`" alt="Video thumbnail"
                  class="video-thumbnail" loading="lazy" />
                <div class="play-button">▶</div>
              </div>
              <iframe v-else :src="`https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1&mute=0`"
                frameborder="0" allowfullscreen loading="lazy"></iframe>
            </div>
          </div>

          <!-- 정보 영역 (오른쪽, 클릭 시 상세 페이지로 이동) -->
          <div class="video-info" @click="goToVideoDetail(video.id)">
            <!-- 작성자 정보 -->
            <div class="video-header">
              <div class="video-author" @click.stop="goToRegistrantArtist(video)">
                <img v-if="video.channelThumbnail" :src="video.channelThumbnail" class="author-avatar-img"
                  alt="채널 이미지" />
                <div v-else class="author-avatar">{{ video.channel ? video.channel.charAt(0).toUpperCase() : '?' }}
                </div>
                <div class="author-info">
                  <div class="author-name-row">
                    <span class="author-name">{{ video.channel }}</span>
                    <button v-if="video.registeredBy"
                      :class="['author-like-button', { 'author-liked': isAuthorLiked(video) }]"
                      @click.stop="handleAuthorLikeClick(video)"
                      :aria-label="isAuthorLiked(video) ? '아티스트 찜 취소' : '아티스트 찜하기'">
                      <svg class="author-like-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                        <path fill="currentColor"
                          d="M12.1 21.35l-1.1-1.02C5.14 15.24 2 12.39 2 8.99 2 6.24 4.24 4 6.99 4c1.54 0 3.04.71 4.01 1.83C11.97 4.71 13.47 4 15.01 4 17.76 4 20 6.24 20 8.99c0 3.4-3.14 6.25-8.9 11.34l-1 1.02z" />
                      </svg>
                    </button>
                  </div>
                  <!-- <span class="author-handle">@{{ video.channel }}</span> -->
                </div>
              </div>
              <div class="video-meta">
                <span class="video-time">{{ formatVideoDate(video.date) }}</span>
                <span class="video-view-count" title="조회수">
                  <img src="@/assets/images/pause.png" alt="조회수" class="video-view-count-icon" />
                  {{ formatViewCount(video.viewCount) }}
                </span>
                <button :class="['like-button', { liked: video.liked }]" @click.stop="handleVideoLikeClick(video.id)">
                  <svg class="like-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path fill="currentColor"
                      d="M12.1 21.35l-1.1-1.02C5.14 15.24 2 12.39 2 8.99 2 6.24 4.24 4 6.99 4c1.54 0 3.04.71 4.01 1.83C11.97 4.71 13.47 4 15.01 4 17.76 4 20 6.24 20 8.99c0 3.4-3.14 6.25-8.9 11.34l-1 1.02z" />
                  </svg>
                  <span class="like-count">{{ getTotalLikes(video) }}</span>
                </button>
                <!-- 더보기 메뉴 -->
                <!-- <div class="more-menu-container">
                  <button class="more-button" @click.stop="toggleMoreMenu(video.id)">
                    <img src="@/assets/images/more_vert.png" alt="더보기" class="more-icon" />
                  </button>
                  <div v-if="openMenuId === video.id" class="dropdown-menu">
                    <button class="dropdown-item" @click.stop="editVideo(video)">
                      ✏️ 수정
                    </button>
                    <button class="dropdown-item dropdown-item-danger" @click.stop="deleteVideo(video)">
                      🗑️ 삭제
                    </button>
                  </div>
                </div> -->
              </div>
            </div>

            <!-- 제목 -->
            <div class="video-title-text">{{ video.title }}</div>

            <!-- 설명 (숨김 처리)
            <div v-if="video.description" class="video-description">{{ video.description }}</div>
            -->

            <!-- 작성자 + 댓글 토글 버튼 (숨김 처리)
            <div class="video-footer-row">
              <button class="comment-toggle" @click.stop="toggleComments(video.id)">
                💬 댓글 {{ getCommentCount(video.id) }}개
                <span class="toggle-arrow">{{ openCommentId === video.id ? '▲' : '▼' }}</span>
              </button>
              <span v-if="video.registeredByName" class="registered-by">
                작성자 : {{ video.registeredByName }}
              </span>
            </div>
            -->

            <!-- 댓글 섹션 (숨김 처리)
            <div v-if="openCommentId === video.id" class="comment-section">
              <div v-if="userStore.isLogin" class="comment-input-wrapper">
                <img v-if="userStore.profileImage" :src="userStore.profileImage" class="comment-my-avatar-img"
                  alt="내 프로필" />
                <div v-else class="comment-my-avatar">{{ userStore.nickname?.charAt(0)?.toUpperCase() || '?' }}</div>
                <div class="comment-input-box">
                  <span class="comment-my-name">{{ userStore.nickname || userStore.email?.split('@')[0] }}</span>
                  <input v-model="newComment[video.id]" type="text" class="comment-input" placeholder="댓글을 입력하세요..."
                    @keyup.enter="addComment(video.id)" />
                </div>
                <button class="comment-submit" @click.stop="addComment(video.id)"
                  :disabled="!newComment[video.id]?.trim()">
                  게시
                </button>
              </div>
              <div v-else class="comment-login-prompt" @click="userStore.showLoginPopup('general')">
                로그인하고 댓글을 남겨보세요 →
              </div>

              <div class="comment-list">
                <div v-if="!videoComments[video.id]?.length" class="no-comments">
                  아직 댓글이 없습니다. 첫 댓글을 남겨보세요!
                </div>
                <div v-for="comment in videoComments[video.id]" :key="comment.id" class="comment-item">
                  <img v-if="comment.userProfileImage" :src="comment.userProfileImage" class="comment-avatar-img"
                    alt="프로필" />
                  <div v-else class="comment-avatar">{{ comment.userName?.charAt(0)?.toUpperCase() || '?' }}</div>
                  <div class="comment-content">
                    <div class="comment-header">
                      <span class="comment-author">{{ comment.userName || '익명' }}</span>
                      <span class="comment-time">{{ formatCommentDate(comment.createdAt) }}</span>
                    </div>
                    <div class="comment-text">{{ comment.text }}</div>
                  </div>
                  <button v-if="userStore.email === comment.userEmail" class="comment-delete"
                    @click.stop="deleteComment(video.id, comment.id)">
                    ✕
                  </button>
                </div>
              </div>
            </div>
          -->
          </div>
        </div>
      </div>
      <!-- 인터섹션 옵저버 기반 무한 스크롤 구현 -->
      <div v-if="paginatedItems.length > 0" ref="loadMoreTrigger" class="load-more-trigger"></div>
      <!-- 페이지네이션 -->
      <div v-if="totalPages > 1" class="pagination">
        <button class="page-button" @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
          ‹
        </button>

        <button v-for="page in pageRange" :key="page" :class="[
          'page-button',
          { 'active-page': page === currentPage },
        ]" @click="goToPage(page)">
          {{ page }}
        </button>

        <button class="page-button" @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">
          ›
        </button>
      </div>
    </div>
    <!-- floating 버튼 -->
    <button v-if="!userStore.isBlocked" @click="openPopup" class="floatingButton">
      <span>+ 신규등록</span>
    </button>
    <!-- 어두운 배경 -->
    <!-- 팝업 -->
    <video-form :is-visible="showPopup" :edit-mode="isEditMode" :edit-data="editVideoData"
      :default-artist="defaultArtist" :default-artist-image="defaultArtistImage" @close-popup="closePopup"
      @upload-success="onUploadSuccess" @update-success="onUpdateSuccess"></video-form>
  </div>
</template>

<script>
import { useUserStore } from "@/store/user";
import VideoForm from "@/components/video/VideoForm.vue";
import scrollManager from "@/utils/scrollManager";
import { trackActivity, ACTIVITY_TYPES } from "@/utils/activityTracker";
import { createNotification } from "@/utils/write/alarm";
import { incrementVideoViewCount } from "@/utils/write/video";
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  deleteDoc,
  addDoc,
  query,
  where,
  orderBy,
  limit,
  startAfter,
  serverTimestamp,
} from "firebase/firestore";
import { ref as storageRef, getDownloadURL } from "firebase/storage";
import { storage } from "/firebaseConfig";

export default {
  name: "VideoList",
  components: {
    VideoForm,
  },
  data() {
    return {
      videos: [],
      filteredVideos: [], // 정렬 및 필터링된 비디오 캐시
      likedVideos: [],
      userArtistLikes: [],
      artistIdCache: {},
      searchQuery: "",
      type: 4,
      userStore: useUserStore(),
      showBookmark: false,
      showPopup: false, // 팝업 상태
      isEditMode: false, // 수정 모드 여부
      editVideoData: null, // 수정할 비디오 데이터
      defaultArtist: "", // 로그인 사용자 본인 아티스트명 (라인업 자동 추가용)
      defaultArtistImage: "", // 본인 아티스트 프로필 이미지 URL
      currentPage: 1,
      itemsPerPage: 12, // 페이지당 표시할 비디오 수
      loadedVideos: {}, // 로드된 비디오 추적
      isIntersectionObserverEnabled: true, // 무한 스크롤 상태
      isLoading: false, // 로딩 상태 추적
      lastDoc: null, // 파이어베이스 페이지네이션을 위한 마지막 문서
      hasMoreVideos: true, // 더 많은 비디오가 있는지 여부
      selectedTypes: { solo: false, duet: false, team: false, dance: false, virtual: false, band: false },
      openMenuId: null, // 현재 열린 더보기 메뉴의 비디오 ID
      showTypeDropdown: false, // 타입 필터 햄버거 드롭다운 열림 여부
      openCommentId: null, // 현재 열린 댓글 섹션의 비디오 ID
      videoComments: {}, // 비디오별 댓글 목록 { videoId: [comments] }
      commentCounts: {}, // 비디오별 댓글 수 { videoId: count }
      newComment: {}, // 비디오별 새 댓글 입력 { videoId: text }
      // 날짜 필터 관련
      showDateFilter: false,
      dateFilterStartYear: "",
      dateFilterStartMonth: "",
      dateFilterEndYear: "",
      dateFilterEndMonth: "",
      dateFilterStart: null,
      dateFilterEnd: null,
      openDropdown: null,
    };
  },
  created() {
    this.getVideos();
    this.fetchLikedVideos();
    this.loadUserArtistLikes();
  },
  mounted() {
    // this.recordVisitor();
    this.setupIntersectionObserver();
    // 외부 클릭 시 메뉴 닫기
    document.addEventListener("click", this.closeMoreMenu);
    document.addEventListener("click", this.handleTypeDropdownClickOutside);
  },
  beforeUnmount() {
    // 인터섹션 옵저버 정리
    if (this.observer) {
      this.observer.disconnect();
    }
    // 스크롤 정리
    scrollManager.unlock("onTilesPopup");
    // 이벤트 리스너 제거
    document.removeEventListener("click", this.closeMoreMenu);
    document.removeEventListener("click", this.handleTypeDropdownClickOutside);
  },
  computed: {
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredItems.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredItems.length / this.itemsPerPage);
    },

    // 페이지 범위 (최대 5개 페이지 버튼 표시)
    pageRange() {
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= 5) {
        const pages = [];
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
        return pages;
      }

      let start, end;

      if (current <= 3) {
        start = 1;
        end = 5;
      } else if (current >= total - 2) {
        start = total - 4;
        end = total;
      } else {
        start = current - 2;
        end = current + 2;
      }

      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
    // 날짜 필터용 년도 목록 (비디오가 존재하는 년도만)
    availableYears() {
      const yearsSet = new Set();
      this.videos.forEach((video) => {
        const date = this.parseVideoDate(video.date);
        if (date) {
          yearsSet.add(date.getFullYear());
        }
      });
      return Array.from(yearsSet).sort((a, b) => b - a);
    },
    // 시작 년도에서 비디오가 존재하는 월 목록
    availableStartMonths() {
      if (!this.dateFilterStartYear) return [];
      const monthsSet = new Set();
      this.videos.forEach((video) => {
        const date = this.parseVideoDate(video.date);
        if (date && date.getFullYear() === this.dateFilterStartYear) {
          monthsSet.add(date.getMonth() + 1);
        }
      });
      return Array.from(monthsSet).sort((a, b) => a - b);
    },
    // 종료 년도 목록 (시작 년도 이상만)
    availableEndYears() {
      let years = this.availableYears;
      if (this.dateFilterStartYear) {
        years = years.filter(year => year >= this.dateFilterStartYear);
      }
      return years;
    },
    // 종료 년도에서 비디오가 존재하는 월 목록 (시작 월 이상만)
    availableEndMonths() {
      if (!this.dateFilterEndYear) return [];
      const monthsSet = new Set();
      this.videos.forEach((video) => {
        const date = this.parseVideoDate(video.date);
        if (date && date.getFullYear() === this.dateFilterEndYear) {
          monthsSet.add(date.getMonth() + 1);
        }
      });
      let months = Array.from(monthsSet).sort((a, b) => a - b);
      // 같은 년도라면 시작 월 이상만 표시
      if (this.dateFilterStartYear && this.dateFilterEndYear === this.dateFilterStartYear && this.dateFilterStartMonth) {
        months = months.filter(month => month >= this.dateFilterStartMonth);
      }
      return months;
    },
    filteredItems() {
      const query = this.searchQuery.toLowerCase();

      // 필터링
      let filtered = this.videos.filter((item) => {
        // 검색어 필터
        let matchesQuery = true;
        if (query) {
          let matchesQueryInTitle = false;
          let matchesQueryInChannel = false;

          if (item.title) {
            matchesQueryInTitle = item.title.toLowerCase().includes(query);
          }
          if (item.channel) {
            matchesQueryInChannel = item.channel.toLowerCase().includes(query);
          }
          matchesQuery = matchesQueryInTitle || matchesQueryInChannel;
        }

        // 타입 필터
        const { solo, duet, team, dance, virtual, band } = this.selectedTypes;
        let matchesType = true;

        // 하나 이상의 타입이 선택된 경우
        if (solo || duet || team || dance || virtual || band) {
          matchesType = false;
          const videoType = item.type || "";
          if (solo && (videoType === "solo" || videoType === "솔로")) matchesType = true;
          if (duet && (videoType === "duet" || videoType === "듀엣")) matchesType = true;
          if (team && (videoType === "team" || videoType === "팀")) matchesType = true;
          if (dance && (videoType === "dance" || videoType === "댄스")) matchesType = true;
          if (virtual && (videoType === "virtual" || videoType === "버츄얼")) matchesType = true;
          if (band && (videoType === "band" || videoType === "밴드")) matchesType = true;
        }

        // 날짜 필터
        let matchesDate = true;
        if (this.dateFilterStart || this.dateFilterEnd) {
          const itemDate = this.parseVideoDate(item.date);
          if (itemDate) {
            if (this.dateFilterStart && itemDate < this.dateFilterStart) {
              matchesDate = false;
            }
            if (this.dateFilterEnd && itemDate > this.dateFilterEnd) {
              matchesDate = false;
            }
          }
        }

        return matchesQuery && matchesType && matchesDate;
      });

      // 정렬
      if (this.type === 1) {
        filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
      } else if (this.type === 2) {
        filtered.sort((a, b) => this.getTotalLikes(b) - this.getTotalLikes(a));
      } else if (this.type === 4) {
        filtered.sort((a, b) => this.getRegisteredTimestamp(b) - this.getRegisteredTimestamp(a));
      } else if (this.type === 3) {
        filtered = filtered.filter((item) =>
          this.likedVideos.includes(item.id)
        );
      }

      return filtered;
    },
    currentSortLabel() {
      if (this.type === 2) return "인기순";
      if (this.type === 4) return "등록순";
      return "최신순";
    },
  },
  watch: {
    "userStore.isLogin"(newVal) {
      if (newVal) {
        this.fetchLikedVideos();
        this.loadUserArtistLikes();
      } else {
        this.videos = this.videos.map((video) => ({
          ...video,
          liked: false,
        }));
        this.likedVideos = [];
        this.userArtistLikes = [];
      }
    },
    type() {
      this.currentPage = 1;
      this.filteredVideos = []; // 캐시 초기화
    },
    searchQuery() {
      this.currentPage = 1;
      this.filteredVideos = []; // 캐시 초기화
    },
    selectedTypes: {
      handler() {
        this.currentPage = 1;
        this.filteredVideos = []; // 캐시 초기화
      },
      deep: true,
    },
  },
  methods: {
    // 전체 좋아요 수 계산을 위한 헬퍼 함수
    getTotalLikes(video) {
      return (
        (video.likes || 0) + (video.tweetLikes || 0) + (video.youtubeLikes || 0)
      );
    },
    formatViewCount(num) {
      const n = Number(num) || 0;
      if (n >= 10000) return `${(n / 10000).toFixed(1).replace(/\.0$/, "")}만`;
      if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, "")}천`;
      return n.toLocaleString();
    },

    // 비디오 클릭 시 실제 iframe 로드
    loadVideo(videoId) {
      this.loadedVideos = { ...this.loadedVideos, [videoId]: true };
      trackActivity(ACTIVITY_TYPES.VIDEO_PLAY, {
        target: "video",
        targetId: videoId,
      }).catch(() => { });
      incrementVideoViewCount(videoId).catch(() => { });
      // 조회수 즉시 화면 반영
      const idx = this.videos.findIndex((v) => v.id === videoId || String(v.id) === String(videoId));
      if (idx !== -1) {
        const v = this.videos[idx];
        this.videos.splice(idx, 1, {
          ...v,
          viewCount: (v.viewCount ?? 0) + 1,
        });
      }
    },

    // 인터섹션 옵저버 설정
    setupIntersectionObserver() {
      if (!("IntersectionObserver" in window)) {
        this.isIntersectionObserverEnabled = false;
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (entry.isIntersecting && !this.isLoading && this.hasMoreVideos) {
            this.loadMore();
          }
        },
        {
          rootMargin: "100px",
          threshold: 0.1,
        }
      );

      if (this.$refs.loadMoreTrigger) {
        this.observer.observe(this.$refs.loadMoreTrigger);
      }
    },

    // 무한 스크롤을 위한 추가 비디오 로드
    async loadMore() {
      if (this.isLoading || !this.hasMoreVideos) return;

      this.isLoading = true;

      try {
        // Firebase 쿼리 로직은 getVideos 메서드에서 처리
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
        }
      } catch (error) {
        console.error("Error loading more videos:", error);
      } finally {
        this.isLoading = false;
      }
    },
    goToPage(page) {
      this.currentPage = page;
    },
    goToVideoDetail(videoId) {
      this.$router.push(`/video/${videoId}`);
    },

    // recordVisitor() {
    // const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
    // const path = `visitorCount/${today}/on`; // 'on' 또는 'off'
    // const dailyPageRef = dbRef(rtdb, path);

    // dbRunTransaction(dailyPageRef, (currentValue) => {
    //   return (currentValue || 0) + 1;
    // });
    // },
    // 찜 필터 버튼 클릭 핸들러 (토글: 다시 누르면 취소)
    handleLikeFilterClick() {
      if (!this.userStore.isLogin) {
        this.userStore.showLoginPopup('likeFilter');
        return;
      }
      this.type = this.type === 3 ? 1 : 3;
    },
    changeType(typeNum) {
      this.type = typeNum;
    },
    async goToRegistrantArtist(video) {
      if (!video.registeredBy) return;
      try {
        const db = getFirestore();
        const q = query(
          collection(db, "artists"),
          where("userEmail", "==", video.registeredBy),
          limit(1)
        );
        const snap = await getDocs(q);
        if (snap.empty) return;
        const artistDoc = snap.docs[0];
        const data = artistDoc.data();
        const routeKey = data.slug ?? artistDoc.id;
        this.$router.push(`/artist/${routeKey}`);
      } catch (err) {
        console.error("아티스트 페이지 이동 실패:", err);
      }
    },
    async loadUserArtistLikes() {
      if (!this.userStore.isLogin) {
        this.userArtistLikes = [];
        return;
      }
      try {
        const { getUserLikes } = await import("@/utils/read/user");
        const likes = await getUserLikes(this.userStore.email);
        this.userArtistLikes = likes.artistLikes || [];
        await this.prefetchArtistIds();
      } catch (err) {
        console.warn("아티스트 찜 목록 로드 실패:", err);
        this.userArtistLikes = [];
      }
    },
    async prefetchArtistIds() {
      const emails = [
        ...new Set(
          this.videos
            .map((v) => v.registeredBy)
            .filter((e) => e && this.artistIdCache[e] === undefined)
        ),
      ];
      if (emails.length === 0) return;
      await Promise.all(emails.map((email) => this.getArtistIdByEmail(email)));
    },
    async getArtistIdByEmail(email) {
      if (!email) return null;
      if (this.artistIdCache[email] !== undefined) return this.artistIdCache[email];
      try {
        const db = getFirestore();
        const q = query(collection(db, "artists"), where("userEmail", "==", email), limit(1));
        const snap = await getDocs(q);
        const artistId = snap.empty ? null : snap.docs[0].id;
        this.artistIdCache = { ...this.artistIdCache, [email]: artistId };
        return artistId;
      } catch (err) {
        console.warn("아티스트 ID 조회 실패:", err);
        return null;
      }
    },
    isAuthorLiked(video) {
      const email = video.registeredBy;
      if (!email) return false;
      const artistId = this.artistIdCache[email];
      if (!artistId) return false;
      return this.userArtistLikes.includes(artistId);
    },
    async handleAuthorLikeClick(video) {
      if (!this.userStore.isLogin) {
        this.userStore.showLoginPopup("artistLike");
        return;
      }
      const email = video.registeredBy;
      if (!email) return;
      const artistId = await this.getArtistIdByEmail(email);
      if (!artistId) return;
      try {
        const { toggleArtistLike } = await import("@/utils/write/user");
        const isCurrentlyLiked = this.userArtistLikes.includes(artistId);
        await toggleArtistLike(artistId, this.userStore.email, isCurrentlyLiked);
        if (isCurrentlyLiked) {
          this.userArtistLikes = this.userArtistLikes.filter((id) => id !== artistId);
        } else {
          this.userArtistLikes = [...this.userArtistLikes, artistId];
        }
      } catch (err) {
        console.error("아티스트 찜 처리 실패:", err);
        if (this.$alert) this.$alert("찜 처리에 실패했습니다. 다시 시도해 주세요.");
      }
    },
    toggleSort() {
      if (this.type === 4) {
        this.type = 1;
      } else if (this.type === 1) {
        this.type = 2;
      } else {
        this.type = 4;
      }
    },
    toggleType(type, event) {
      this.selectedTypes[type] = !this.selectedTypes[type];
      if (event?.target) {
        this.$nextTick(() => {
          this.scrollTypeButtonIntoView(event.target);
        });
      }
    },
    resetTypes(event) {
      this.selectedTypes = { solo: false, duet: false, team: false, dance: false, virtual: false, band: false };
      if (event?.target) {
        this.$nextTick(() => {
          this.scrollTypeButtonIntoView(event.target);
        });
      }
    },
    scrollTypeButtonIntoView(btn) {
      const container = this.$refs.typeFilterScroll;
      if (!container || !btn) return;
      const containerRect = container.getBoundingClientRect();
      const btnRect = btn.getBoundingClientRect();
      const scrollLeft = container.scrollLeft + (btnRect.left - containerRect.left) - (containerRect.width / 2) + (btnRect.width / 2);
      container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    },
    // iOS 호환 날짜 파싱 헬퍼 함수
    parseVideoDate(dateStr) {
      if (!dateStr) return null;
      try {
        // "yyyy-MM-dd HH:mm:ss" 또는 "yyyy.MM.dd HH:mm" 형식 처리
        const cleanStr = dateStr.replace(/\./g, "-").trim();
        const parts = cleanStr.split(' ');
        const datePart = parts[0];
        const timePart = parts[1] || '00:00:00';

        const [year, month, day] = datePart.split('-').map(Number);
        const timeParts = timePart.split(':').map(Number);
        const hour = timeParts[0] || 0;
        const minute = timeParts[1] || 0;

        return new Date(year, month - 1, day, hour, minute);
      } catch {
        return null;
      }
    },
    getRegisteredTimestamp(video) {
      const registeredAt = video?.registeredAt;

      if (registeredAt && typeof registeredAt.toMillis === "function") {
        return registeredAt.toMillis();
      }

      if (registeredAt && typeof registeredAt.seconds === "number") {
        const nanos = typeof registeredAt.nanoseconds === "number" ? registeredAt.nanoseconds : 0;
        return registeredAt.seconds * 1000 + Math.floor(nanos / 1000000);
      }

      if (registeredAt instanceof Date) {
        return registeredAt.getTime();
      }

      if (typeof registeredAt === "string" || typeof registeredAt === "number") {
        // iOS Safari 호환을 위해 기존 문자열 포맷(yyyy.MM.dd HH:mm / yyyy-MM-dd HH:mm:ss)은 parseVideoDate 우선
        const parsedByHelper = this.parseVideoDate(String(registeredAt));
        if (parsedByHelper) return parsedByHelper.getTime();

        const parsed = new Date(registeredAt).getTime();
        if (!Number.isNaN(parsed)) return parsed;
      }

      // 과거 데이터 호환: 일부 문서는 createdAt에만 등록 시각이 남아있을 수 있음
      const createdAt = video?.createdAt;
      if (createdAt && typeof createdAt.toMillis === "function") {
        return createdAt.toMillis();
      }
      if (createdAt && typeof createdAt.seconds === "number") {
        const nanos = typeof createdAt.nanoseconds === "number" ? createdAt.nanoseconds : 0;
        return createdAt.seconds * 1000 + Math.floor(nanos / 1000000);
      }
      if (createdAt instanceof Date) {
        return createdAt.getTime();
      }
      if (typeof createdAt === "string" || typeof createdAt === "number") {
        const parsedByHelper = this.parseVideoDate(String(createdAt));
        if (parsedByHelper) return parsedByHelper.getTime();
        const parsed = new Date(createdAt).getTime();
        if (!Number.isNaN(parsed)) return parsed;
      }

      // registeredAt이 없으면 기존 date 기준으로 fallback
      const fallbackDate = this.parseVideoDate(video?.date);
      return fallbackDate ? fallbackDate.getTime() : 0;
    },
    // 날짜 필터 관련 메서드
    toggleDateFilter() {
      this.showDateFilter = !this.showDateFilter;
      this.openDropdown = null;
    },
    toggleDropdown(dropdown) {
      this.openDropdown = this.openDropdown === dropdown ? null : dropdown;
    },
    selectYear(type, year) {
      if (type === 'start') {
        this.dateFilterStartYear = year;
        if (!year) this.dateFilterStartMonth = "";
      } else {
        this.dateFilterEndYear = year;
        if (!year) this.dateFilterEndMonth = "";
      }
      this.openDropdown = null;
    },
    selectMonth(type, month) {
      if (type === 'start') {
        this.dateFilterStartMonth = month;
      } else {
        this.dateFilterEndMonth = month;
      }
      this.openDropdown = null;
    },
    resetDateFilter() {
      this.dateFilterStartYear = "";
      this.dateFilterStartMonth = "";
      this.dateFilterEndYear = "";
      this.dateFilterEndMonth = "";
      this.dateFilterStart = null;
      this.dateFilterEnd = null;
      this.openDropdown = null;
      this.currentPage = 1;
    },
    applyDateFilter() {
      // 시작 날짜 설정
      if (this.dateFilterStartYear && this.dateFilterStartMonth) {
        this.dateFilterStart = new Date(this.dateFilterStartYear, this.dateFilterStartMonth - 1, 1);
      } else if (this.dateFilterStartYear) {
        this.dateFilterStart = new Date(this.dateFilterStartYear, 0, 1);
      } else {
        this.dateFilterStart = null;
      }

      // 종료 날짜 설정 (해당 월의 마지막 날)
      if (this.dateFilterEndYear && this.dateFilterEndMonth) {
        this.dateFilterEnd = new Date(this.dateFilterEndYear, this.dateFilterEndMonth, 0, 23, 59, 59);
      } else if (this.dateFilterEndYear) {
        this.dateFilterEnd = new Date(this.dateFilterEndYear, 11, 31, 23, 59, 59);
      } else {
        this.dateFilterEnd = null;
      }

      this.showDateFilter = false;
      this.currentPage = 1;
    },
    // 더보기 메뉴 토글
    toggleMoreMenu(videoId) {
      if (this.openMenuId === videoId) {
        this.openMenuId = null;
      } else {
        this.openMenuId = videoId;
      }
    },
    // 메뉴 닫기 (외부 클릭 시)
    closeMoreMenu() {
      this.openMenuId = null;
    },
    toggleTypeDropdown() {
      this.showTypeDropdown = !this.showTypeDropdown;
    },
    selectTypeFromDropdown(key) {
      if (key === "all") {
        this.selectedTypes = { solo: false, duet: false, team: false, dance: false, virtual: false, band: false };
      } else {
        this.selectedTypes = {
          solo: false,
          duet: false,
          team: false,
          dance: false,
          virtual: false,
          band: false,
          [key]: true,
        };
      }
      this.showTypeDropdown = false;
      this.$nextTick(() => {
        const container = this.$refs.typeFilterScroll;
        if (!container) return;
        const activeBtn = container.querySelector('.activeType');
        if (activeBtn) this.scrollTypeButtonIntoView(activeBtn);
      });
    },
    handleTypeDropdownClickOutside(event) {
      const el = this.$refs.typeDropdownContainer;
      if (el && !el.contains(event.target)) {
        this.showTypeDropdown = false;
      }
    },
    // 비디오 수정
    editVideo(video) {
      this.openMenuId = null;
      this.editVideoData = video;
      this.isEditMode = true;
      this.showPopup = true;
      scrollManager.lock("onTilesPopup");
    },
    // 비디오 삭제
    async deleteVideo(video) {
      this.openMenuId = null;

      if (!this.userStore.isLogin) {
        this.$alert("로그인이 필요한 서비스입니다.");
        return;
      }

      const confirmed = await this.$confirm(`"${video.title}" 영상을 삭제하시겠습니까?`);
      if (!confirmed) return;

      try {
        const db = getFirestore();
        const videoRef = doc(db, "videos", video.id);
        await deleteDoc(videoRef);

        // 로컬 목록에서 제거
        this.videos = this.videos.filter(v => v.id !== video.id);
        this.$alert("삭제되었습니다.");
      } catch (error) {
        console.error("삭제 실패:", error);
        this.$alert("삭제에 실패했습니다.");
      }
    },
    // 댓글 섹션 토글
    async toggleComments(videoId) {
      if (this.openCommentId === videoId) {
        this.openCommentId = null;
      } else {
        this.openCommentId = videoId;
        // 댓글이 아직 로드되지 않았으면 로드
        if (!this.videoComments[videoId]) {
          await this.loadComments(videoId);
        }
      }
    },
    // 댓글 수 가져오기
    getCommentCount(videoId) {
      return this.commentCounts[videoId] || 0;
    },
    // 댓글 목록 로드
    async loadComments(videoId) {
      try {
        const db = getFirestore();
        const commentsRef = collection(db, "videos", videoId, "comments");
        const q = query(commentsRef, orderBy("createdAt", "desc"), limit(50));
        const snapshot = await getDocs(q);

        const comments = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));

        this.videoComments = { ...this.videoComments, [videoId]: comments };
        this.commentCounts = { ...this.commentCounts, [videoId]: comments.length };
      } catch (error) {
        console.error("댓글 로드 실패:", error);
        this.videoComments = { ...this.videoComments, [videoId]: [] };
      }
    },
    // 댓글 추가
    async addComment(videoId) {
      const text = this.newComment[videoId]?.trim();
      if (!text) return;

      if (!this.userStore.isLogin) {
        this.$alert("로그인이 필요한 서비스입니다.");
        return;
      }

      try {
        const db = getFirestore();
        const commentsRef = collection(db, "videos", videoId, "comments");

        const commentData = {
          text,
          userEmail: this.userStore.email,
          userName: this.userStore.nickname || this.userStore.name || this.userStore.email.split('@')[0],
          userProfileImage: this.userStore.profileImage || null,
          createdAt: serverTimestamp(),
        };

        const docRef = await addDoc(commentsRef, commentData);

        // 활동 추적
        trackActivity(ACTIVITY_TYPES.VIDEO_COMMENT, {
          target: "video",
          targetId: videoId,
        });

        // 로컬 목록에 추가 (맨 위에)
        const newCommentObj = {
          id: docRef.id,
          ...commentData,
          createdAt: new Date(), // 로컬용 임시 시간
        };

        const currentComments = this.videoComments[videoId] || [];
        this.videoComments = {
          ...this.videoComments,
          [videoId]: [newCommentObj, ...currentComments]
        };
        this.commentCounts = {
          ...this.commentCounts,
          [videoId]: (this.commentCounts[videoId] || 0) + 1
        };

        // 입력 필드 초기화
        this.newComment = { ...this.newComment, [videoId]: '' };
      } catch (error) {
        console.error("댓글 추가 실패:", error);
        this.$alert("댓글 추가에 실패했습니다.");
      }
    },
    // 댓글 삭제
    async deleteComment(videoId, commentId) {
      try {
        const db = getFirestore();
        const commentRef = doc(db, "videos", videoId, "comments", commentId);
        await deleteDoc(commentRef);

        // 로컬 목록에서 제거
        const currentComments = this.videoComments[videoId] || [];
        this.videoComments = {
          ...this.videoComments,
          [videoId]: currentComments.filter(c => c.id !== commentId)
        };
        this.commentCounts = {
          ...this.commentCounts,
          [videoId]: Math.max(0, (this.commentCounts[videoId] || 0) - 1)
        };
      } catch (error) {
        console.error("댓글 삭제 실패:", error);
        this.$alert("댓글 삭제에 실패했습니다.");
      }
    },
    // 댓글 날짜 포맷
    formatCommentDate(date) {
      if (!date) return '';

      // Firestore Timestamp 처리
      const d = date.toDate ? date.toDate() : new Date(date);
      const now = new Date();
      const diffMs = now - d;
      const diffMinutes = Math.floor(diffMs / (1000 * 60));
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      if (diffMinutes < 1) return '방금 전';
      if (diffMinutes < 60) return `${diffMinutes}분 전`;
      if (diffHours < 24) return `${diffHours}시간 전`;
      if (diffDays < 7) return `${diffDays}일 전`;

      return d.toLocaleDateString('ko-KR', { month: '2-digit', day: '2-digit' });
    },
    onUploadSuccess() {
      // ✅ 리스트 새로고침 - 상태 초기화 후 다시 로드
      this.videos = [];
      this.filteredVideos = [];
      this.lastDoc = null;
      this.hasMoreVideos = true;
      this.currentPage = 1;
      this.getVideos();
    },
    onUpdateSuccess() {
      // ✅ 리스트 새로고침 - 상태 초기화 후 다시 로드
      this.videos = [];
      this.filteredVideos = [];
      this.lastDoc = null;
      this.hasMoreVideos = true;
      this.currentPage = 1;
      this.getVideos();
    },
    // 영상 찜 버튼 클릭 핸들러
    handleVideoLikeClick(vid) {
      if (!vid) return;
      if (!this.userStore.isLogin) {
        this.userStore.showLoginPopup("videoLike");
        return;
      }
      const email = this.userStore.email;
      if (!email) {
        this.userStore.showLoginPopup("videoLike");
        return;
      }
      this.likeVideoSafely(email, vid);
    },
    async likeVideoSafely(userId, videoId) {
      if (!userId || !videoId) return;
      try {
        const { toggleVideoLike } = await import("@/utils/write/user");
        const isLiked = await toggleVideoLike(videoId, userId);

        if (!Array.isArray(this.videos)) return;
        const index = this.videos.findIndex((v) => v.id === videoId || String(v.id) === String(videoId));
        if (index === -1) return;

        const video = this.videos[index];
        const newLikesCount = isLiked
          ? (video.likes || 0) + 1
          : Math.max(0, (video.likes || 0) - 1);

        this.videos.splice(index, 1, {
          ...video,
          liked: isLiked,
          likes: newLikesCount,
        });

        if (isLiked) {
          if (!this.likedVideos.includes(videoId)) {
            this.likedVideos = [...this.likedVideos, videoId];
          }
          // 영상 등록자에게 알림 전송 (본인 영상이면 제외)
          const ownerEmail = video.registeredBy;
          if (ownerEmail && ownerEmail !== userId) {
            try {
              const videoTitle = video.title?.length > 25 ? video.title.substring(0, 25) + "..." : (video.title || "영상");
              await createNotification({
                userId: ownerEmail,
                type: "VIDEO_LIKE",
                title: "영상에 찜을 받았어요! 💖",
                message: `${this.userStore.nickname || "누군가"}님이 "${videoTitle}" 영상을 찜했습니다.`,
                targetType: "video",
                targetId: videoId,
                fromUserId: userId,
                fromUserNickname: this.userStore.nickname || null,
              });
            } catch (notifError) {
              console.warn("영상 찜 알림 전송 실패:", notifError);
            }
          }
        } else {
          this.likedVideos = this.likedVideos.filter((id) => id !== videoId);
        }
      } catch (error) {
        console.error("좋아요 처리 중 오류 발생:", error);
        if (this.$alert) this.$alert("찜 처리에 실패했습니다. 다시 시도해 주세요.");
      }
    },
    async getVideos() {
      if (this.isLoading) return;
      this.isLoading = true;

      try {
        const db = getFirestore();
        const videosRef = collection(db, "videos");

        // 페이지네이션을 위한 쿼리 구성
        let videoQuery;

        if (!this.lastDoc) {
          // 첫 페이지 로드
          videoQuery = query(
            videosRef,
            orderBy("date", "desc"),
            limit(50) // 한 번에 더 많은 비디오 가져오기
          );
        } else if (this.hasMoreVideos) {
          // 추가 페이지 로드
          videoQuery = query(
            videosRef,
            orderBy("date", "desc"),
            startAfter(this.lastDoc),
            limit(50)
          );
        } else {
          this.isLoading = false;
          return;
        }

        const querySnapshot = await getDocs(videoQuery);

        // 결과가 비어있으면 더 이상 비디오가 없음
        if (querySnapshot.empty) {
          this.hasMoreVideos = false;
          this.isLoading = false;
          return;
        }

        // 마지막 문서 저장
        this.lastDoc = querySnapshot.docs[querySnapshot.docs.length - 1];

        const newVideos = querySnapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter((video) => {
            // ✅ 필수 필드가 존재하고 공백이 아닌 경우만 통과
            return (
              video.title &&
              video.title.trim() !== "" &&
              video.channel &&
              video.channel.trim() !== "" &&
              video.date &&
              !isNaN(new Date(video.date)) // 유효한 날짜인지 체크
            );
          });

        if (this.videos.length === 0) {
          this.videos = newVideos;
        } else {
          // 중복 비디오 방지
          const existingIds = new Set(this.videos.map((v) => v.id));
          const uniqueNewVideos = newVideos.filter(
            (v) => !existingIds.has(v.id)
          );
          this.videos = [...this.videos, ...uniqueNewVideos];
        }

        // 좋아요 상태 업데이트
        if (this.userStore.isLogin && this.likedVideos.length > 0) {
          this.videos = this.videos.map((video) => ({
            ...video,
            liked: this.likedVideos.includes(video.id),
          }));
        }

        // 필터링된 비디오 캐시 초기화
        this.filteredVideos = [];

        // 아티스트 ID 미리 캐싱 (찜 상태 표시용)
        this.prefetchArtistIds();
      } catch (error) {
        console.error("Error fetching videos:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchLikedVideos() {
      this.likedVideos = [];
      if (!this.userStore.isLogin) {
        console.warn("로그인이 필요한 서비스입니다.");
        return;
      }
      try {
        const { getUserLikes } = await import("@/utils/read/user");
        const likes = await getUserLikes(this.userStore.email);
        this.likedVideos = likes.videoLikes || likes.likes || [];
        // ✅ this.videos에 liked 상태 추가
        this.videos = this.videos.map((video) => ({
          ...video,
          liked: this.likedVideos.includes(video.id),
        }));
      } catch (error) {
        console.error("likedVideos 불러오기 실패:", error);
      }
    },
    signIn() {
      this.userStore.showLoginPopup("general");
    },
    async openPopup() {
      this.isEditMode = false;
      this.editVideoData = null;
      this.defaultArtist = "";
      this.defaultArtistImage = "";
      if (this.userStore.isLogin && this.userStore.email) {
        try {
          const db = getFirestore();
          const q = query(
            collection(db, "artists"),
            where("userEmail", "==", this.userStore.email),
            limit(1)
          );
          const snap = await getDocs(q);
          if (snap.empty) {
            this.$alert("먼저 아티스트 카드를 만들어야 합니다! \n 아티스트 등록 페이지로 이동합니다.").then(() => {
              this.$router.push("/artist");
            });
            return;
          }
          const data = snap.docs[0].data();
          const artistName = data.name || snap.docs[0].id;
          this.defaultArtist = artistName;
          // 프로필 이미지 URL 가져오기
          if (data.userProfileImg) {
            try {
              const imageRef = storageRef(storage, `profile/${data.userProfileImg}`);
              this.defaultArtistImage = await getDownloadURL(imageRef);
            } catch (err) {
              console.warn("본인 아티스트 프로필 이미지 로드 실패:", err);
            }
          } else if (data.img) {
            try {
              const imageRef = storageRef(storage, `artist/${data.img}`);
              this.defaultArtistImage = await getDownloadURL(imageRef);
            } catch (err) {
              console.warn("본인 아티스트 프로필 이미지 로드 실패:", err);
            }
          }
        } catch (e) {
          console.warn("본인 아티스트 조회 실패:", e);
        }
      }
      this.showPopup = true;
      scrollManager.lock("onTilesPopup");
    },
    closePopup() {
      this.showPopup = false;
      this.isEditMode = false;
      this.editVideoData = null;
      this.defaultArtistImage = "";
      scrollManager.unlock("onTilesPopup");
    },
    fullLogout() {
      if (this.userStore) this.userStore.logOut();
      if (window.Kakao && window.Kakao.Auth) {
        window.Kakao.Auth.logout();
      }
      this.$router.push("/");
    },
    formatVideoDate(dateStr) {
      if (!dateStr) return "";
      try {
        const date = new Date(dateStr);
        const now = new Date();
        const diffMs = now - date;
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffMinutes = Math.floor(diffMs / (1000 * 60));
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        if (diffMinutes < 1) {
          return "방금 전";
        } else if (diffMinutes < 60) {
          return `${diffMinutes}분 전`;
        } else if (diffHours < 24) {
          return `${diffHours}시간 전`;
        } else if (diffDays < 7) {
          return `${diffDays}일 전`;
        } else {
          return date.toLocaleDateString("ko-KR", {
            month: "2-digit",
            day: "2-digit",
          });
        }
      } catch (error) {
        return dateStr.substring(0, 10);
      }
    },
  },
};
</script>

<style scoped>
.video-list-wrapper {
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(180deg, #fdf8f5 0%, #f5eef8 35%, #f0f4ff 100%);
  padding-bottom: 24px;
}

.container {
  width: 90%;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.video-feed {
  padding: 10px;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.video-card {
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 16px;
  transition: all 0.25s ease;
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  border: 1px solid rgba(139, 107, 184, 0.08);
  box-shadow: 0 2px 12px rgba(45, 27, 78, 0.04);
}

.video-card:hover {
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 6px 24px rgba(45, 27, 78, 0.1);
}

.video-card:last-child {
  margin-bottom: 0;
}

/* 썸네일 래퍼 (왼쪽) */
.video-thumbnail-wrapper {
  flex-shrink: 0;
  width: 240px;
  padding: 10px;
}

/* 정보 영역 (오른쪽) */
.video-info {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  min-width: 0;
  cursor: pointer;
}

/* 썸네일 관련 스타일 */
.video-container {
  width: 100%;
  position: relative;
  height: 0;
  padding-bottom: 56.25%;
  /* 16:9 비율 */
  border-radius: 14px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 4px 16px rgba(45, 27, 78, 0.1);
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.thumbnail-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
}

.video-thumbnail {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.2s;
}

.thumbnail-container:hover .video-thumbnail {
  opacity: 0.7;
}

.play-button {
  position: absolute;
  color: white;
  font-size: 48px;
  opacity: 0.8;
  transition: opacity 0.2s, transform 0.2s;
}

.thumbnail-container:hover .play-button {
  opacity: 1;
  transform: scale(1.2);
}

/* 로딩 트리거 스타일 */
.load-more-trigger {
  height: 20px;
  margin: 20px 0;
}

/* 비디오 헤더 (작성자 정보) */
.video-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.author-name-row {
  display: flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
}

.author-like-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 3px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
  color: #bdbdbd;
}

.author-like-button:hover {
  background: rgba(255, 107, 157, 0.1);
  transform: scale(1.15);
  color: #ff6b9d;
}

.author-like-button.author-liked {
  color: #ff6b9d;
  animation: heartBeat 0.6s ease-in-out;
}

.author-like-icon {
  width: 17px;
  height: 17px;
  transition: color 0.2s ease;
}

.video-author {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
  cursor: pointer;
}

.author-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #b8a9d4 0%, #e8b4d4 50%, #a8d4f0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 1rem;
  flex-shrink: 0;
  font-family: "NanumSquareRoundB", sans-serif;
  box-shadow: 0 2px 8px rgba(139, 107, 184, 0.2);
}

.author-avatar-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.author-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.author-name {
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: bold;
  font-size: 0.9375rem;
  color: #2d1b4e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.author-handle {
  font-size: 0.875rem;
  color: #7b6b94;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.video-meta {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.video-time {
  font-size: 0.875rem;
  color: #7b6b94;
}

.video-view-count {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.8125rem;
  color: #7b6b94;
  font-family: "NanumSquareRoundR", sans-serif;
  white-space: nowrap;
  margin-left: 4px;
}

.video-view-count-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  /* 사이트 테마 색(#7b6b94)으로 아이콘 색상 덮기 */
  filter: brightness(0) saturate(100%) invert(62%) sepia(18%) saturate(1023%) hue-rotate(248deg) brightness(95%) contrast(90%);
}

/* 찜 버튼 스타일 (ArtistCard와 동일) */
.like-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.like-button:hover {
  background: rgba(255, 107, 157, 0.1);
  transform: scale(1.1);
}

.like-button:hover .like-icon {
  transform: scale(1.1);
}

.like-button.liked {
  animation: heartBeat 0.6s ease-in-out;
}

.like-icon {
  width: 20px;
  height: 20px;
  transition: all 0.2s ease;
  color: #bdbdbd;
}

.like-count {
  font-size: 0.8125rem;
  font-family: "NanumSquareRoundR", sans-serif;
  color: #7b6b94;
}

.like-button.liked .like-icon {
  color: #ff6b9d;
}

.like-button.liked .like-count {
  color: #b86bb8;
}

/* 더보기 메뉴 */
.more-menu-container {
  position: relative;
}

.more-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.more-button:hover {
  background: rgba(0, 0, 0, 0.05);
}

.more-icon {
  width: 20px;
  height: 20px;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.more-button:hover .more-icon {
  opacity: 1;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(139, 107, 184, 0.15);
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(45, 27, 78, 0.12);
  min-width: 120px;
  z-index: 100;
  overflow: hidden;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundR", sans-serif;
  color: #2d1b4e;
  text-align: left;
  transition: background 0.2s ease;
}

.dropdown-item:hover {
  background: rgba(139, 107, 184, 0.06);
}

.dropdown-item-danger {
  color: #dc3545;
}

.dropdown-item-danger:hover {
  background: #fff5f5;
}

/* 댓글 토글 버튼 */
.comment-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 0;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundR", sans-serif;
  color: #536471;
  transition: color 0.2s ease;
}

.comment-toggle:hover {
  color: #8b6bb8;
}

.toggle-arrow {
  font-size: 0.625rem;
  transition: transform 0.2s ease;
}

/* 댓글 섹션 */
.comment-section {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #e1e8ed;
}

/* 댓글 입력 */
.comment-input-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
}

.comment-my-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #b8a9d4 0%, #e8b4d4 50%, #a8d4f0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 0.875rem;
  flex-shrink: 0;
  font-family: "NanumSquareRoundB", sans-serif;
}

.comment-my-avatar-img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.comment-input-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.comment-my-name {
  font-size: 0.8125rem;
  font-family: "NanumSquareRoundB", sans-serif;
  color: #0f1419;
}

.comment-login-prompt {
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 12px;
  text-align: center;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundR", sans-serif;
  color: #66bdff;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 12px;
}

.comment-login-prompt:hover {
  background: #e8f4ff;
  color: #4a9eff;
}

.comment-input {
  flex: 1;
  padding: 10px 14px;
  border: 1px solid #e1e8ed;
  border-radius: 20px;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundR", sans-serif;
  outline: none;
  transition: border-color 0.2s ease;
}

.comment-input:focus {
  border-color: #66bdff;
}

.comment-input::placeholder {
  color: #9ca3af;
}

.comment-submit {
  padding: 10px 18px;
  background: #66bdff;
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundB", sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.comment-submit:hover:not(:disabled) {
  background: #4a9eff;
}

.comment-submit:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* 댓글 목록 */
.comment-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
}

.no-comments {
  text-align: center;
  color: #9ca3af;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundR", sans-serif;
  padding: 20px 0;
}

/* 댓글 아이템 */
.comment-item {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.comment-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #66bdff 0%, #ff69b4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 0.75rem;
  flex-shrink: 0;
  font-family: "NanumSquareRoundB", sans-serif;
}

.comment-avatar-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.comment-content {
  flex: 1;
  min-width: 0;
}

.comment-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.comment-author {
  font-size: 0.8125rem;
  font-family: "NanumSquareRoundB", sans-serif;
  color: #0f1419;
}

.comment-time {
  font-size: 0.75rem;
  color: #536471;
  font-family: "NanumSquareRoundR", sans-serif;
}

.comment-text {
  font-size: 0.875rem;
  font-family: "NanumSquareRoundR", sans-serif;
  color: #0f1419;
  line-height: 1.4;
  word-break: break-word;
}

.comment-delete {
  background: none;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  font-size: 0.75rem;
  padding: 4px;
  border-radius: 50%;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.comment-delete:hover {
  color: #dc3545;
  background: #fff5f5;
}

@keyframes heartBeat {
  0% {
    transform: scale(1);
  }

  14% {
    transform: scale(1.3);
  }

  28% {
    transform: scale(1);
  }

  42% {
    transform: scale(1.3);
  }

  70% {
    transform: scale(1);
  }
}

.video-title-text {
  font-family: "NanumSquareRoundR", sans-serif;
  font-size: 0.875rem;
  color: #2d1b4e;
  line-height: 1.5;
  padding: 5px;
  word-wrap: break-word;
}

.video-title-link {
  text-decoration: none;
  cursor: pointer;
  display: block;
  transition: color 0.2s ease;
}

.video-title-link:hover {
  color: #1d9bf0;
  white-space: normal;
}

.video-description {
  font-size: 0.875rem;
  color: #536471;
  line-height: 1.4;
  word-wrap: break-word;
  font-family: "NanumSquareRoundR", sans-serif;
}

.video-footer-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 4px;
}

.registered-by {
  font-size: 0.8125rem;
  color: #9ca3af;
  font-family: "NanumSquareRoundR", sans-serif;
  white-space: nowrap;
}

.likes-icon {
  width: 16px;
  height: 16px;
}

.likes-text {
  padding-left: 1px;
  padding-bottom: 2px;
}

/* 필터 및 검색 컨트롤 */
.controls {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  padding: 10px;
}

.typeFilter {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  min-width: 0;
}

.typeDropdown {
  position: relative;
  flex-shrink: 0;
}

.dropdownToggle {
  height: 34px;
  width: 34px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(139, 107, 184, 0.2);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.dropdownToggle:hover {
  background: rgba(255, 255, 255, 0.95);
  border-color: rgba(139, 107, 184, 0.35);
}

.dehazeIcon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  filter: brightness(0) invert(0.4);
}

.typeDropdownMenu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(139, 107, 184, 0.15);
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(45, 27, 78, 0.12);
  z-index: 9999;
  min-width: 120px;
  max-height: min(320px, 50vh);
  overflow-y: auto;
  animation: typeDropdownSlide 0.2s ease;
}

@keyframes typeDropdownSlide {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.typeDropdownItem {
  width: 100%;
  padding: 10px 14px;
  background: transparent;
  border: none;
  text-align: left;
  font-size: 0.875rem;
  color: #7b6b94;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: "NanumSquareRoundR", sans-serif;
  border-bottom: 1px solid rgba(139, 107, 184, 0.08);
}

.typeDropdownItem:last-child {
  border-bottom: none;
}

.typeDropdownItem:hover {
  background: rgba(139, 107, 184, 0.06);
  color: #2d1b4e;
}

.typeDropdownItem.activeTypeDropdownItem {
  background: linear-gradient(135deg, #8b6bb8 0%, #a88bc4 100%);
  color: white;
  font-weight: bold;
}

.typeFilterScroll {
  display: flex;
  gap: 8px;
  align-items: center;
  overflow-x: auto;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.typeFilterScroll::-webkit-scrollbar {
  display: none;
}

.likeButton {
  padding: 5px 7px;
  border: 1px solid rgba(139, 107, 184, 0.25);
  background: rgba(255, 255, 255, 0.7);
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}


.activeLike {
  background: linear-gradient(135deg, #8b6bb8 0%, #a88bc4 100%);
  color: white;
  border-color: transparent;
}


.likeIcon {
  width: 20px;
  height: 20px;
  margin-top: 3px;
}

.typeButton {
  padding: 8px 16px;
  border: 1px solid rgba(139, 107, 184, 0.25);
  background: rgba(255, 255, 255, 0.7);
  color: #7b6b94;
  border-radius: 12px;
  cursor: pointer;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundB", sans-serif;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.activeType {
  background: linear-gradient(135deg, #8b6bb8 0%, #a88bc4 100%);
  color: white;
  border-color: transparent;
}

.registerButton {
  padding: 8px 16px;
  background: #66bdff;
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundB", sans-serif;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.registerButton:hover {
  background: #4a9eff;
}

.plusIcon {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

.sortFilter {
  flex: 1;
  display: flex;
  gap: 8px;
  min-width: 200px;
}

.searchBox {
  flex: 1;
  min-width: 100px;
  width: 100%;
}

.searchInput {
  width: 100%;
  height: 34px !important;
  padding: 0 12px;
  border: 1px solid rgba(139, 107, 184, 0.2);
  border-radius: 10px;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundR", sans-serif;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  background: rgba(255, 255, 255, 0.7);
}

.searchInput:focus {
  outline: none;
  border-color: rgba(139, 107, 184, 0.5);
  box-shadow: 0 0 0 3px rgba(139, 107, 184, 0.1);
}

.filterBox {
  flex-shrink: 0;
}

/* 날짜 필터 스타일 */
.dateFilterWrapper {
  position: relative;
  flex-shrink: 0;
}

.dateFilterButton {
  width: 30px;
  height: 30px;
  padding: 5px;
  border: 1px solid rgba(139, 107, 184, 0.25);
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.dateFilterButton:active {
  border-color: rgba(139, 107, 184, 0.5);
}

.dateFilterActive {
  background: linear-gradient(135deg, #8b6bb8 0%, #a88bc4 100%);
  border-color: transparent;
}

.dateFilterActive .calendarIcon {
  filter: brightness(0) invert(1);
}

.calendarIcon {
  width: 18px;
  height: 18px;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.dateFilterButton:hover .calendarIcon {
  opacity: 0.8;
}

.dateFilterDropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 260px;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(139, 107, 184, 0.15);
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(45, 27, 78, 0.12);
  z-index: 100;
  overflow: visible;
}

.dateFilterBody {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dateFilterRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dateFilterLabel {
  font-family: "NanumSquareRoundB", sans-serif;
  font-size: 0.75rem;
  color: #666;
  width: 32px;
  flex-shrink: 0;
}

/* 커스텀 드롭다운 */
.customSelect {
  flex: 1;
  position: relative;
  padding: 7px 8px;
  border: 1px solid rgba(139, 107, 184, 0.25);
  border-radius: 8px;
  font-size: 0.75rem;
  font-family: "NanumSquareRoundR", sans-serif;
  background: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: border-color 0.2s ease;
  user-select: none;
}

.customSelect:hover {
  border-color: rgba(139, 107, 184, 0.5);
}

.customSelect.disabled {
  background: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}

.customSelectText {
  color: #333;
}

.customSelect.disabled .customSelectText {
  color: #999;
}

.customSelectArrow {
  font-size: 0.625rem;
  color: #999;
  margin-left: 4px;
}

.customSelectOptions {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(139, 107, 184, 0.15);
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(45, 27, 78, 0.1);
  max-height: 150px;
  overflow-y: auto;
  z-index: 10;
}

.customSelectOption {
  padding: 7px 8px;
  font-size: 0.75rem;
  cursor: pointer;
  transition: background 0.15s ease;
}

.customSelectOption:hover {
  background: rgba(139, 107, 184, 0.08);
}

.customSelectOption.selected {
  background: linear-gradient(135deg, #8b6bb8 0%, #a88bc4 100%);
  color: white;
}

.customSelectOption.selected:hover {
  background: linear-gradient(135deg, #9b7bc8 0%, #b89bd4 100%);
}

.dateFilterFooter {
  display: flex;
  gap: 6px;
  padding: 10px 12px;
  border-top: 1px solid rgba(139, 107, 184, 0.08);
  background: rgba(245, 238, 248, 0.5);
  border-radius: 0 0 14px 14px;
}

.dateFilterReset {
  flex: 1;
  padding: 9px;
  border: 1px solid rgba(139, 107, 184, 0.25);
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  font-family: "NanumSquareRoundR", sans-serif;
  font-size: 0.75rem;
  color: #7b6b94;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dateFilterReset:hover {
  border-color: rgba(139, 107, 184, 0.4);
  background: rgba(255, 255, 255, 1);
}

.dateFilterApply {
  flex: 1;
  padding: 9px;
  border: none;
  background: linear-gradient(135deg, #8b6bb8 0%, #a88bc4 100%);
  border-radius: 8px;
  font-family: "NanumSquareRoundB", sans-serif;
  font-size: 0.75rem;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dateFilterApply:hover {
  opacity: 0.95;
  transform: translateY(-1px);
}

.sortButton {
  padding: 8px 12px;
  background: linear-gradient(135deg, #8b6bb8 0%, #a88bc4 100%);
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundB", sans-serif;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.sortButton:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(139, 107, 184, 0.3);
}

.sortIcon {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

.desktopOnly {
  display: flex;
}

/* Floating 버튼 스타일 */
.floatingButton {
  position: fixed;
  right: calc(50% - 500px);
  max-width: 1024px;
  margin-right: 12px;
  height: 46px;
  padding: 0px 12px;
  border-radius: 30px;
  background: linear-gradient(135deg, #8b6bb8 0%, #a88bc4 100%);
  color: white;
  border: none;
  box-shadow: 0 4px 20px rgba(139, 107, 184, 0.4);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 199;
  font-size: 1rem;
  font-weight: bold;
  font-family: "NanumSquareRoundB", sans-serif !important;
  transition: all 0.3s ease;
  bottom: 80px !important;
}

@media screen and (max-width: 1024px) {
  .floatingButton {
    right: 12px;
  }
}

.floatingButton:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 24px rgba(139, 107, 184, 0.5);
}

.floatingButton:active {
  transform: scale(0.95);
}

.typeIcon {
  padding: 5px;
  /* 배경과 글씨 사이의 여백 */
  margin: 0px 2px;
  border-radius: 15px;
  /* 배경의 모서리를 둥글게 */
  height: 15px !important;
  width: 15px !important;
  border: 1px solid;
}

/* 어두운 배경 */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* 어둡게 */
  z-index: 10;
}

/* 팝업 스타일 */
.popup {
  width: 90%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 90%;
  max-height: 90%;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  z-index: 20;
  text-align: center;
  margin: auto;
  overflow-y: scroll;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  gap: 6px;
  flex-wrap: wrap;
}

.page-button {
  padding: 6px 10px;
  border: 1px solid rgba(139, 107, 184, 0.2);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.8);
  color: #7b6b94;
  font-size: 0.8125rem;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 32px;
  text-align: center;
}

.page-button:hover:not(.active-page):not(:disabled) {
  background: rgba(255, 255, 255, 0.95);
  border-color: rgba(139, 107, 184, 0.4);
  color: #2d1b4e;
}

.page-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  color: #aaa;
  background: rgba(255, 255, 255, 0.5);
}

.active-page {
  background: linear-gradient(135deg, #8b6bb8 0%, #a88bc4 100%);
  color: #ffffff;
  border-color: transparent;
}


/* ========================================
   Small (~480px)
   ======================================== */
@media screen and (max-width: 480px) {
  .container {
    box-sizing: border-box;
  }

  /* 필터/컨트롤 */
  .controls {
    gap: 8px;
    padding: 10px 0;
  }

  .typeFilter {
    gap: 6px;
  }

  .typeFilterScroll {
    gap: 6px;
  }

  .dropdownToggle {
    height: 28px;
    width: 28px;
    border-radius: 6px;
  }

  .dehazeIcon {
    width: 18px;
    height: 18px;
  }

  .typeDropdownMenu {
    min-width: 110px;
    max-height: min(280px, 45vh);
    top: calc(100% + 6px);
  }

  .typeDropdownItem {
    padding: 8px 12px;
    font-size: 0.8125rem;
  }

  .typeButton {
    padding: 6px 12px;
    font-size: 0.75rem;
  }

  .typeButton:hover {
    border-color: #ddd;
    color: #666;
    background: white;
  }

  .activeType:hover {
    background: linear-gradient(135deg, #8b6bb8 0%, #a88bc4 100%);
    color: white;
    border-color: transparent;
  }

  .likeButton {
    padding: 4px 6px;
  }

  .likeButton:active {
    background: #ff6b9d;
    border-color: #ff6b9d;
  }

  .likeIcon {
    width: 18px;
    height: 18px;
  }

  /* 검색/정렬 */
  .sortFilter {
    min-width: 0;
    gap: 6px;
    flex-wrap: wrap;
  }

  .searchBox {
    min-width: 0;
    flex: 1;
  }

  .searchInput {
    height: 31px !important;
    font-size: 0.75rem;
    padding: 0 10px;
  }

  .filterBox {
    flex-shrink: 0;
  }

  .sortButton {
    padding: 8px 10px;
    font-size: 0.75rem;
  }

  .sortButton:hover {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(139, 107, 184, 0.3);
  }

  .sortIcon {
    width: 14px;
    height: 14px;
  }

  /* 날짜 필터 */
  .dateFilterWrapper {
    flex-shrink: 0;
  }

  .dateFilterButton {
    width: 28px;
    height: 28px;
    padding: 4px;
  }

  .calendarIcon {
    width: 16px;
    height: 16px;
  }

  .dateFilterDropdown {
    width: calc(100vw - 32px);
    max-width: 280px;
    left: 0;
  }

  .dateFilterBody {
    padding: 10px;
    gap: 8px;
  }

  .dateFilterRow {
    gap: 6px;
  }

  .dateFilterLabel {
    font-size: 0.6875rem;
    width: 28px;
  }

  .customSelect {
    padding: 6px 6px;
    font-size: 0.6875rem;
  }

  .customSelectOption {
    padding: 6px 8px;
    font-size: 0.6875rem;
  }

  .dateFilterFooter {
    padding: 8px 10px;
    gap: 6px;
  }

  .dateFilterReset,
  .dateFilterApply {
    padding: 8px;
    font-size: 0.6875rem;
  }

  /* 비디오 피드/카드 */
  .video-feed {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
  }

  .video-card {
    flex-direction: column;
  }

  .video-thumbnail-wrapper {
    width: 100%;
  }

  .video-info {
    gap: 8px;
  }

  .video-header {
    flex-wrap: wrap;
    gap: 8px;
  }

  .author-avatar,
  .author-avatar-img {
    width: 32px;
    height: 32px;
    font-size: 0.875rem;
  }

  .author-name {
    font-size: 0.8125rem;
  }

  .author-handle {
    font-size: 0.75rem;
  }

  .video-title-text {
    font-size: 0.8125rem;
    line-height: 1.4;
  }

  .video-time {
    font-size: 0.75rem;
  }

  .video-view-count {
    font-size: 0.75rem;
  }

  .video-view-count-icon {
    width: 14px;
    height: 14px;
  }

  .video-meta {
    flex-wrap: wrap;
  }

  .like-button {
    padding: 4px 8px;
  }

  .like-icon {
    width: 16px;
    height: 16px;
  }

  .like-count {
    font-size: 0.75rem;
  }

  .more-button {
    padding: 4px;
  }

  .more-icon {
    width: 18px;
    height: 18px;
  }

  .dropdown-menu {
    min-width: 100px;
    padding: 4px 0;
  }

  .dropdown-item {
    padding: 8px 12px;
    font-size: 0.8125rem;
  }

  .registered-by {
    font-size: 0.75rem;
  }

  /* 데스크톱 전용 버튼 숨김 */
  .desktopOnly {
    display: none !important;
  }

  /* 플로팅 버튼 */
  .floatingButton {
    display: flex;
  }

  /* 페이지네이션 */
  .pagination {
    gap: 4px;
    margin-top: 18px;
  }

  .page-button {
    padding: 5px 8px;
    font-size: 0.6875rem;
    min-width: 26px;
    border-radius: 5px;
  }

  /* 로드 트리거 */
  .load-more-trigger {
    margin: 12px 0;
  }
}

.text {
  font-size: 18px;
  font-family: var(--font-nanum-r), sans-serif;
  font-weight: 600;
  color: #808080;
  /* Off 상태 텍스트 색상 */
  transition: color 0.3s ease;
  padding: 5px 7px;
  margin-top: 2px;
}
</style>
